<template>
<div>
  <div style="margin-bottom: 40px;">
    <el-row :gutter="24">
<!--      <el-col :span="4">-->
<!--        <div style="display: flex;">-->
<!--          <span style="white-space: nowrap;display: flex;align-items: center;">流程名称：</span>-->
<!--          <el-input v-model="tableWhere.flow_name" size="mini" placeholder="请输入流程名称"></el-input>-->
<!--        </div>-->
<!--      </el-col>-->
      <el-col :span="4">
        <div style="display: flex;">
          <span style="white-space: nowrap;display: flex;align-items: center;">流程标题：</span>
          <el-input v-model="tableWhere.flow_title" size="mini" placeholder="请输入流程标题"></el-input>
        </div>
      </el-col>
      <el-col :span="4">
        <div style="display: flex;">
          <span style="white-space: nowrap;display: flex;align-items: center;">流程编号：</span>
          <el-input v-model="tableWhere.serial_number" size="mini" placeholder="请输入流水号"></el-input>
        </div>
      </el-col>
      <el-col :span="3">
        <div style="display: flex;">
          <span style="white-space: nowrap;display: flex;align-items: center;">发起人：</span>
          <el-input v-model="tableWhere.user_name" size="mini" placeholder="请输入发起人"></el-input>
        </div>
      </el-col>
      <el-col :span="5">
        <div style="display: flex;">
          <span style="white-space: nowrap;display: flex;align-items: center;">发起日期：</span>
          <el-date-picker
            v-model="tableWhere.date_range"
            size="mini"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
      </el-col>
      <el-col :span="3">
        <div style="display: flex;">
          <span style="white-space: nowrap;display: flex;align-items: center;">紧急程度：</span>
          <el-select v-model="tableWhere.urgency_level" size="mini" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>

          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div>
          <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
          <el-button size="mini" type="success text2" @click="exportExecl()">导出</el-button>
        </div>
      </el-col>
      <el-col :span="1">
        <div>

        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="4">
        <div style="display: flex;">
          <span style="white-space: nowrap;display: flex;align-items: center;">流程状态：</span>
          <el-select v-model="tableWhere.status" size="mini" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option label="在处理" value="1"></el-option>
            <el-option label="已结束" value="2"></el-option>
            <el-option label="已拒绝" value="3"></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div style="display: flex;">
          <span style="white-space: nowrap;display: flex;align-items: center;">流程类型：</span>
          <el-select v-model="tableWhere.master_id" size="mini" clearable filterable placeholder="请选择">
            <el-option v-for="item in masterList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div style="display: flex;">
          <span style="white-space: nowrap;display: flex;align-items: center;">发起部门：</span>
          <el-input v-model="tableWhere.ancestor_name" size="mini" placeholder="输入部门名称"></el-input>
        </div>
      </el-col>
      <el-col :span="10">
        <div style="display: flex;">
          <span style="white-space: nowrap;display: flex;align-items: center;">选择发起部门：</span>
          <el-input v-model="tableWhere.department_name" size="mini" placeholder="" @focus="showSelectDepartment" readonly></el-input>
          <el-input type="hidden" v-model="tableWhere.department_id" size="mini"></el-input>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="4">
        <div v-if="selectType == 'schedule' ">
<!--          <el-button size="mini" type="warning text2" @click="batchApprove">批量审批</el-button>-->
        </div>
      </el-col>
    </el-row>


  </div>
  <div class="table-wrap">
    <el-table
      v-loading="loading"
      :data="pageData.list"
      :default-sort = "{}"
      @selection-change="handleSelectionChange"
      border
      style="width: 100%">
      <el-table-column
        type="selection"
        width="40">
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="urgency_level"-->
<!--        sortable-->
<!--        label="紧急程度"-->
<!--        width="50">-->
<!--        <template slot-scope="scope">-->
<!--          <el-tag type="danger" effect="dark" v-if="scope.row.urgency_level == 3">-->
<!--            加急-->
<!--          </el-tag>-->
<!--          <el-tag type="warning" effect="dark" v-if="scope.row.urgency_level == 2">-->
<!--            紧急-->
<!--          </el-tag>-->
<!--          <el-tag effect="dark" v-if="scope.row.urgency_level == 1">-->
<!--            一般-->
<!--          </el-tag>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="task_id" label="ID" width="100"></el-table-column>-->
      <el-table-column
        prop="process_name"
        label="标题">
        <template slot-scope="scope">
          <template v-if="selectType == 'refill'">
            <el-link type="primary" @click="ERP.navigateTo('/flow/FlowView?sheet_id='+scope.row.sheet_id+'&task_id='+scope.row.task_id+'&master_id='+scope.row.master_id)">{{scope.row.process_name}}</el-link>
          </template>
          <template v-else>
            <el-link type="primary" @click="ERP.navigateTo('/flow/FlowView?sheet_id='+scope.row.sheet_id+'&task_id='+scope.row.task_id+'&node_id='+scope.row.node_id+'&master_id='+scope.row.master_id+'&step_id='+scope.row.id)">{{scope.row.process_name}}</el-link>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="serial_number"
        label="流水号"
        width="200">
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="master_name"-->
<!--        label="流程类别"-->
<!--        width="200">-->
<!--      </el-table-column>-->
      <el-table-column
        prop="user_name"
        label="发起单位/所有人"
        width="80">
      </el-table-column>
      <el-table-column
        label="状态"
        width="80">
        <template slot-scope="scope">
          <!--          {{scope.row.is_finish?'已结束':'在处理'}}-->
          <template v-if="scope.row.flow_status > 0">
            <el-tag v-if="scope.row.flow_status == 9" type="danger">已拒绝</el-tag>
            <el-tag v-if="scope.row.flow_status == 10" type="danger">撤销</el-tag>
            <el-tag v-if="scope.row.flow_status == 11" type="danger">重填</el-tag>
            <el-tag v-if="scope.row.flow_status == 1 && scope.row.is_finish == 1" type="success">已结束</el-tag>
            <el-tag v-if="scope.row.flow_status == 1 && scope.row.is_finish == 0" type="danger">在处理</el-tag>
          </template>
          <template v-else>
            <el-tag v-if="scope.row.is_finish && scope.row.flow_status != 9" type="success">已结束</el-tag>
            <el-tag v-if="!scope.row.is_finish" type="danger">在处理</el-tag>
          </template>

        </template>
      </el-table-column>
      <el-table-column
        prop="action_user_name"
        label="当前处理人"
        width="90">
      </el-table-column>
      <el-table-column
        prop="action_node_name"
        label="当前步骤"
        width="150">
      </el-table-column>
      <el-table-column
        prop="date_time"
        sortable
        label="接收时间"
        width="135">
        <template slot-scope="scope">
<!--          {{scope.row.finish_time||scope.row.handle_time||scope.row.posted_time||scope.row.receive_time}}-->
          {{scope.row.posted_time}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button v-if="scope.row.is_approve == '未审批' " type="danger" size="mini" @click="revocation(scope.row.task_id)">撤回</el-button>
          <el-button v-if="scope.row.is_approve != '未审批' && scope.row.is_return == 1 && scope.row.is_finish != 1" type="primary" size="mini" @click="goBack(scope.row.task_id, scope.row.id)">取回</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <select-department ref="selectDepartment" />
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
  </div>

</div>
</template>

<script>
import Http from "../common/Http";
import selectDepartment from "../../Personnel/components/selectDepartment"
import CommonHelp from "../../Oa/common/CommonHelp";

export default {
  components:{selectDepartment},
  name: "ProcessSteps",
  props:{
    where:{
      type:Object,
      default(){
        return {};
      }
    },
    selectType:{
      type:String,
      default(){
        return '';
      }
    }
  },
  data(){
    return{
      $_where:{},
      loading:true,
      pageData:{
        list:[],
        total:0,
        pageSize:15,
        page:1
      },
      tableWhere:{
        urgency_level:'',
        flow_title:'',
        flow_name:'',
        date_range:'',
        user_name:'',
        serial_number:'',
        master_id:'',
        department_id:'',
        department_name:'',
        ancestor_name:''
      },
      defaultSort : {},
      selectFlow: [],
      type: '',
      masterList: {}
    }
  },
  activated() {
    this.getList()
    this.getMasterList()
  },
  methods:{
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      this.getMasterList()
      const that = this;
      that.loading=true;
      let searchWhere = {...that.where, ...that.tableWhere};
      let where=JSON.parse(JSON.stringify(searchWhere));
      Http.get("flow/FlowProcessSteps/getProcessStepsList",{
        where:JSON.stringify(where),
        field:"task.serial_number,task.sheet_id,task.process_name,task.user_id,task.task_id,task.master_id,task.is_finish,task.urgency_level,fps.id,fps.select_action,fps.node_id,fps.posted_time,fps.handle_time,fps.receive_time,fps.finish_time",
        page: this.pageData.page,
        page_size: this.pageData.pageSize,
        type: this.selectType
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    getMasterList() {
      const that = this;
      let searchWhere = {page : 1, page_size : 1000};
      Http.get("flow/FlowMaster/getList",searchWhere,res=>{
        if(res.code) {
          that.masterList = res.data.list
        } else {
          that.masterList = {}
        }
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    revocation(taskId) {
      let that = this;
      that.loading=true;
      this.$confirm('此操作将撤回审批单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Http.get("flow/FlowForm/revocationFlowForm",{
          task_id:taskId,
        },res=>{
          if(res.code) {
            that.getList();
          }
          that.loading=false;
        })
      }).catch(() => {
        that.loading=false;
      });
    },
    searchs() {
      this.pageData.page = 1
      this.getList()
    },
    exportExecl() {
      const that = this;
      that.loading=true;
      let searchWhere = {...that.where, ...that.tableWhere};
      let where=JSON.parse(JSON.stringify(searchWhere));
      Http.get("flow/FlowProcessSteps/exportExecl",{
        where:JSON.stringify(where),
        field:"task.serial_number,task.sheet_id,task.process_name,task.user_id,task.task_id,task.master_id,task.is_finish,task.urgency_level,fps.id,fps.select_action,fps.node_id,fps.posted_time,fps.handle_time,fps.receive_time,fps.finish_time",
        type: this.selectType
      },res=>{
        if(res.code) {
          window.open(Http.getBaseURL() + res.data.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message({
            message: '导出失败',
            type: 'error'
          });
        }
        that.loading=false;
      })
    },
    handleSelectionChange(val) {
      this.selectFlow = val;
    },
    // 取回流程
    goBack(task_id, step_id) {
      if (task_id == false) {
        this.$message.warning('请选择需要取回的流程！');
        return false;
      }
      // taskIds = taskIds.toString()
      Http.post("flow/FlowHandle/goBack", {
        taskId: task_id,
        stepId: step_id,
      }, res => {
        if (res.code) {
          this.getList()
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    batchApprove() {
      let taskIds = [];
      let selectFlow = this.selectFlow
      for(let i = 0; i < selectFlow.length; i++) {
        taskIds.push(selectFlow[i]['task_id'])
      }
      if (selectFlow.length > 0) {
        Http.post("flow/FlowHandle/batchApprove", {
          task_ids: taskIds,
        }, res => {
          if (res.code) {
            this.getList()
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请选择需要审批的流程单')
      }
    },
    showSelectDepartment() {
      let that = this
      this.$refs.selectDepartment.show({}, data=>{
        that.tableWhere.department_name = data['ancestor_name']
        that.tableWhere.department_id = data['id']
      })
    }
  },
  watch:{
    where:{
      deep:true,
      immediate:true,
      handler(n){
        // 如果是待办理则按照等级排序
        if (n['fps.is_handle'] == 0) {
          this.defaultSort = {prop: 'urgency_level', order: 'descending'}
        } else {
          this.defaultSort = {}
        }
        n&&this.getList();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/ProcessSteps.vue